import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { fire, auth } from "../../firebase/index";
import withAuthorization from "../../components/Authorization/withAuthorization";
import { customLog } from "../../variables/Variables";
import ReactTooltip from "react-tooltip";
//helper class
import LanguageSetting from "./languageSetting";
import TutorialSetting from "./tutorialSetting";
import PasswordSetting from "./passwordSetting";
import ProfileSetting from "./profileSetting";
import BatterySetting from "./batterySetting";
import ThemeSetting from "./themeSetting";
import AuthenticationSetting from "./authenticationSetting";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
// img
import tooltipIcon from "../../assets/img/tooltipIcon.png";

import LocalizedStrings from "react-localization";
import { isSuper } from "@babel/types";
let localizationStrings = new LocalizedStrings({
  en: {
    setting: "Settings",
    accountNavigator: "Account",
    passwordNavigator: "Password",
    othersNavigator: "Others",
    authenticationNavigator: "Authentication",
    languageTitle: "Language",
    tutorialTitle: "Starter Guide",
    passwordTitle: "Password",
    batteryTitle: "Battery Notification",
    themeTitle: "Dark Mode",
    batteryToolTip:
      "Turn on to allow pop-up notifications when you have low battery on any listed lock.",
  },
  ja: {
    setting: "設定",
    accountNavigator: "アカウント",
    passwordNavigator: "パスワード",
    othersNavigator: "その他",
    authenticationNavigator: "認証",
    languageTitle: "ランゲージ",
    tutorialTitle: "スターターガイド",
    passwordTitle: "パスワード",
    batteryTitle: "充電残量",
    themeTitle: "ダークモード",
    batteryToolTip:
      "バッテリー残量が少ないことを知らせるポップアップ通知をONにします。",
  },
  es: {
    setting: "Configuraciones",
    accountNavigator: "Cuenta",
    passwordNavigator: "Contraseña",
    othersNavigator: "Otros",
    authenticationNavigator: "Autenticación",
    languageTitle: "Idioma",
    tutorialTitle: "Guía de Inicio",
    passwordTitle: "Contraseña",
    batteryTitle: "Notificación de Batería",
    themeTitle: "Modo Oscuro",
    batteryToolTip:
      "Activa para permitir notificaciones emergentes cuando tengas poca batería en cualquier candado listada.",
  },
});

class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userSettings: [],
      isSuperAdmin: false,
    };

    //? all function
  }

  componentWillMount() {
    fire
      .database()
      .ref("userSettings")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists) {
          this.setState({
            userSettings: snapshot.val(),
          });
        }
      });
    //! FOR LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    // Check for superadmin status
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();
            // customLog(superAdminData.members);
            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              // customLog(memberDetails[eachMember]);
              const eachMemberDetails = memberDetails[eachMemberId];
              // customLog(eachMemberDetails.memberEmail);
              const eachMemberEmail = eachMemberDetails.memberEmail;
              // customLog(eachMemberDetails);

              // if (eachMemberEmail === auth.currentUser.email) {
              if (eachMemberEmail === auth.currentUser.email) {
                this.setState({
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                });
              }
            }
          });
        }
      });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    // Check for super admin status, if super admin, allow authentication tab
    if (this.state.isSuperAdmin) {
      return (
        <div style={{ width: "95%", marginLeft: "auto", marginRight: "auto" }}>
          <div className="header">
            <h2>{localizationStrings.setting}</h2>
          </div>
          <br />

          <div>
            <Tabs forceRenderTabPanel defaultIndex={0}>
              <TabList>
                <Tab>{localizationStrings.accountNavigator}</Tab>
                {/* <Tab>{localizationStrings.passwordNavigator}</Tab>
                <Tab>{localizationStrings.othersNavigator}</Tab> */}
                <Tab>{localizationStrings.authenticationNavigator}</Tab>
              </TabList>

              <TabPanel>
                <div className="settingPageRow">
                  <ProfileSetting />
                </div>
                <div className="horizontalLongLine" />
                <div className="settingPageRowPassword">
                  <p style={{ marginTop: "10px" }}>
                    {localizationStrings.passwordTitle}
                  </p>
                  <PasswordSetting />
                </div>
                <div className="horizontalLongLine" />
                <div className="settingPageRowLang">
                  <p>{localizationStrings.languageTitle}</p>
                  <LanguageSetting />
                </div>
                {/* <div className="horizontalLongLine" /> */}
                {/* <div className="settingPageRowOthers">
                  <p>{localizationStrings.tutorialTitle}</p>
                  <TutorialSetting />
                </div> */}
                {/* <div className="horizontalLongLine" /> */}
                <div className="settingPageRowOthers">
                  <div style={{ display: "flex" }}>
                    <p>{localizationStrings.batteryTitle}</p>
                    {/* <img style={{height: "20px", marginLeft: "10px"}} src={tooltipIcon} alt="tooltipIcon" /> */}
                    <a data-tip data-for="batteryTip">
                      <span
                        style={{
                          color: "#3C3E41",
                          fontSize: "20px",
                          marginLeft: "10px",
                        }}
                        className="glyphicon glyphicon-info-sign"
                        aria-hidden="true"
                      ></span>
                    </a>
                    <ReactTooltip id="batteryTip" effect="solid">
                      <span>{localizationStrings.batteryToolTip}</span>
                    </ReactTooltip>
                  </div>
                  <BatterySetting />
                </div>
                <br />
              </TabPanel>

              {/* Can use AccountManagement/ResetPassword.js for this tab panel */}
              {/* <TabPanel>
                <div className="settingPageRowPassword">
                  <p style={{ marginTop: "10px" }}>
                    {localizationStrings.passwordTitle}
                  </p>
                  <PasswordSetting />
                </div>
              </TabPanel> */}

              {/* <TabPanel>
                <div className="settingPageRowLang">
                  <p>{localizationStrings.languageTitle}</p>
                  <LanguageSetting />
                </div>
                <div className="settingPageRowOthers">
                  <p>{localizationStrings.tutorialTitle}</p>
                  <TutorialSetting />
                </div>
                <div className="settingPageRowOthers">
                  <p>{localizationStrings.batteryTitle}</p>
                  <BatterySetting />
                </div>
              </TabPanel> */}

              <TabPanel>
                <div className="settingPageRow">
                  <AuthenticationSetting />
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ width: "95%", marginLeft: "auto", marginRight: "auto" }}>
          <div className="header">
            <h2>{localizationStrings.setting}</h2>
          </div>
          <br />

          <div>
            <Tabs forceRenderTabPanel defaultIndex={0}>
              <TabList>
                <Tab>{localizationStrings.accountNavigator}</Tab>
                {/* <Tab>{localizationStrings.passwordNavigator}</Tab>
              <Tab>{localizationStrings.othersNavigator}</Tab> */}
                {/* <Tab>{localizationStrings.authenticationNavigator}</Tab> */}
              </TabList>

              <TabPanel>
                <div className="settingPageRow">
                  <ProfileSetting />
                </div>
                <div className="horizontalLongLine" />
                <div className="settingPageRowPassword">
                  <p style={{ marginTop: "10px" }}>
                    {localizationStrings.passwordTitle}
                  </p>
                  <PasswordSetting />
                </div>
                <div className="horizontalLongLine" />
                <div className="settingPageRowLang">
                  <p>{localizationStrings.languageTitle}</p>
                  <LanguageSetting />
                </div>
                {/* <div className="horizontalLongLine" /> */}
                {/* <div className="settingPageRowOthers">
                <p>{localizationStrings.tutorialTitle}</p>
                <TutorialSetting />
              </div> */}
                {/* <div className="horizontalLongLine" /> */}
                <div className="settingPageRowOthers">
                  <div style={{ display: "flex" }}>
                    <p>{localizationStrings.batteryTitle}</p>
                    {/* <img style={{height: "20px", marginLeft: "10px"}} src={tooltipIcon} alt="tooltipIcon" /> */}
                    <a data-tip data-for="batteryTip">
                      <span
                        style={{
                          color: "#3C3E41",
                          fontSize: "20px",
                          marginLeft: "10px",
                        }}
                        className="glyphicon glyphicon-info-sign"
                        aria-hidden="true"
                      ></span>
                    </a>
                    <ReactTooltip id="batteryTip" effect="solid">
                      <span>{localizationStrings.batteryToolTip}</span>
                    </ReactTooltip>
                  </div>
                  <BatterySetting />
                </div>
                <br />
              </TabPanel>

              {/* Can use AccountManagement/ResetPassword.js for this tab panel */}
              {/* <TabPanel>
              <div className="settingPageRowPassword">
                <p style={{ marginTop: "10px" }}>
                  {localizationStrings.passwordTitle}
                </p>
                <PasswordSetting />
              </div>
            </TabPanel> */}

              {/* <div className="horizontalLongLine" /> */}
              {/* <TabPanel>
              <div className="settingPageRowLang">
                <p>{localizationStrings.languageTitle}</p>
                <LanguageSetting />
              </div>
              <div className="settingPageRowOthers">
                <p>{localizationStrings.tutorialTitle}</p>
                <TutorialSetting />
              </div>
              <div className="settingPageRowOthers">
                <p>{localizationStrings.batteryTitle}</p>
                <BatterySetting />
              </div>
            </TabPanel> */}

              {/* <TabPanel>
              <div className="settingPageRow">
                <AuthenticationSetting />
              </div>
            </TabPanel> */}
            </Tabs>
          </div>
        </div>
      );
    }
  }
}
const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(Setting);
